import { Box, Link, Typography } from "@mui/material"
import React from "react"
import { useNavigate, useParams } from "react-router-dom"
import { customPalette } from "../../../../../../../theme"
import { ValidateButton } from "../../../../../../components/buttons/ValidateButton/ValidateButton"
import { IconInfoCircle } from "../../../../../../components/custom-icons/icon-info-circle"
import { pagesUrl } from "../../../../../../core/appConstants"
import { resolveUrl } from "../../../../../../core/services/http-service"

export function BSBimModelListEmpty(): React.JSX.Element {
  const navigate = useNavigate()
  const { projectId } = useParams()

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2} width="80%" p={2}>
      <Typography fontSize="24px" fontWeight={600} lineHeight="36px" color={customPalette.darkBlue3}>
        Gagnez du temps et fiabilisez vos quantitatifs
      </Typography>
      <Typography variant="body1" py={1} textAlign="center">
        Pourquoi saisir manuellement vos données quand une maquette numérique Beem peut tout faire pour vous ?
        <br />
        En déposant votre maquette, vous automatisez l’extraction des quantitatifs et profitez d’une précision optimale grâce
        à la géométrie réelle de votre projet.
      </Typography>
      <ValidateButton
        label="Ajouter une maquette"
        onClick={() => navigate(resolveUrl(pagesUrl.BIM_MODEL_IMPORT_PAGE, [projectId, "new"]))}
      />

      <Box display="flex" alignItems="center" gap={1}>
        <IconInfoCircle sx={{ color: customPalette.black }} />
        <Typography variant="body1" py={1} textAlign="center">
          Maquette Beem + estimation Shot = Beem Shot ! On vous explique 👉
        </Typography>
        <Link href="https://timetobeem.com/beem-shot/" underline="hover" target="_blank" rel="noopener noreferrer">
          timetobeem.com/beem-shot
        </Link>
      </Box>
    </Box>
  )
}
